export default __webpack_public_path__ + "static/media/step2.8e2428df.png";